/*
 * Follows the Keyboard event matrix at:
 * https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
 */

export const Tab = 0x09; // 9
export const Enter = 0x0d; // 13
export const Escape = 0x1b; // 27
export const Space = 0x20; // 32
export const ArrowLeft = 0x25; // 37
export const ArrowUp = 0x26; // 38
export const ArrowRight = 0x27; // 39
export const ArrowDown = 0x28; // 40
